import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import React, { useRef } from "react";
import { useLandingReveal, type UseLandingRevealOptions } from "#/features/homePage/ui/landing/useLandingReveal";
type LandingRevealProps = {
  children: React.ReactNode;
  /** Optional layout sx merged after reveal styles (e.g. margin). */
  sx?: SxProps<Theme>;
} & UseLandingRevealOptions;

/** Wraps block-level landing content for scroll-triggered entrance. */
export const LandingReveal: React.FC<LandingRevealProps> = t0 => {
  const $ = _c(8);
  const {
    children,
    sx,
    staggerMs: t1
  } = t0;
  const staggerMs = t1 === undefined ? 0 : t1;
  const ref = useRef(null);
  let t2;
  if ($[0] !== staggerMs) {
    t2 = {
      staggerMs
    };
    $[0] = staggerMs;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    revealSx
  } = useLandingReveal(ref, t2);
  let t3;
  if ($[2] !== revealSx || $[3] !== sx) {
    t3 = sx ? [revealSx, sx] : revealSx;
    $[2] = revealSx;
    $[3] = sx;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const mergedSx = t3 as SxProps<Theme>;
  let t4;
  if ($[5] !== children || $[6] !== mergedSx) {
    t4 = <Box ref={ref} sx={mergedSx}>{children}</Box>;
    $[5] = children;
    $[6] = mergedSx;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};